import { render } from "./StudentListObservation.vue?vue&type=template&id=199e82b9"
import script from "./StudentListObservation.vue?vue&type=script&lang=js"
export * from "./StudentListObservation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__